export default function useWhitelabelCustomization() {
  const whitelabelCustomization =
    window.whitelabelCustomization === "%WHITELABEL_CUSTOMIZATION%"
      ? undefined
      : window.whitelabelCustomization;

  return { whitelabelCustomization };
}
